 export default {name: 'WButtonGroup'} 